import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { MonthlyDailyReport } from "../../Services/Dashboard";
import moment from "moment/moment";
import SpinnerModal from "../../Spinner/SpinnerModal";
import DataTableExtensions from "react-data-table-component-extensions";
import { Button } from "@mui/material";
import "./Reports.css";

const DailyReports = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dailyReports, setDailyReports] = useState([]);
const [FilterYear,setYear] = useState();
  // Fetch Monthly Daily Reports
  const GetMonthlyDaily = async (Year) => {
    try {
      setIsLoading(true);
      const LabID = sessionStorage.getItem("LabID");
      const response = await MonthlyDailyReport(LabID,Year);
      setDailyReports(response.dailyReports);
    } catch (error) {
      toast.error("Unable to get data", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
     const currentDate = new Date();
     const Year = currentDate.getFullYear();
     GetMonthlyDaily(Year);
  }, []);

  //------------------------FILTER
  const handleChange = (e) => {
    
  const selectedYear = e.target.value;
  setYear(selectedYear);

};
const Applyfilter = () =>{
  GetMonthlyDaily(FilterYear);
}
  // Define table columns
  const columns = [
    {
      name: "Date",
      selector: (row) => moment(row.recordDate).format("D MMM YYYY"),
      cellExport: (row) => row.recordDate,
      sortable: true,
    },
    {
      name: "Day",
      selector: (row) => row.dayName,
      cellExport: (row) => row.dayName,
      sortable: true,
    },
    {
      name: "Tests",
      selector: (row) => row.totalTest,
      cellExport: (row) => row.totalTest,
      sortable: true,
    },
    {
      name: "Sale",
      selector: (row) => row.totalGrandTotal,
      cellExport: (row) => row.totalGrandTotal,
      sortable: true,
    },
    {
      name: "Discount",
      selector: (row) => row.totalDiscount,
      cellExport: (row) => row.totalDiscount,
      sortable: true,
    },
    {
      name: "Received Amount",
      selector: (row) => row.receivedAmount,
      cellExport: (row) => row.receivedAmount,
      sortable: true,
    },
    {
      name: "Due Amount",
      selector: (row) => row.dueAmount,
      cellExport: (row) => row.dueAmount,
      sortable: true,
    },
  ];
  const tableData = {
    columns,
    data: dailyReports,
  };
  const customStyles = {
    rows: {
      style: {
        borderBottom: '1px solid #ccc', // Row border
      },
    },
    cells: {
      style: {
        borderRight: '1px solid #ccc', // Column border
      },
    },
    headCells: {
      style: {
        borderTop:'1px solid #ccc',
        borderRight: '1px solid #ccc', // Column border in header
        backgroundColor: 'white',
      },
    },
  };
  return (
    <>
      {isLoading && <SpinnerModal isLoading={isLoading} />}
      <div className="reports-container">
        <div className='row d-flex justify-content-end'>
          <div className='col-sm-2'>
            <label className='common-Labels'>Year Filter<span className='common-Asterisk'>*</span></label>
              <select className="form-select  common-Input"
                    id='Year'
                    name='Year'
                    required
                    onChange={handleChange}
                    >
                      
                       <option value='2026'>2026</option>  
                    <option value='2025'>2025</option>  
                    <option value='2024'>2024</option>  
                    <option value='2023'>2023</option>  
                </select>
            </div>
            <div  className='col-sm-1 mt-4'>
                <Button  variant="contained" onClick={Applyfilter}  type='button' className="common-button">Apply</Button>
            </div>
        </div>
        <hr></hr>
        <DataTableExtensions {...tableData}>
          <DataTable
            pagination
            fixedHeader
            fixedHeaderScrollHeight="80vh"
            highlightOnHover
            pointerOnHover
            responsive
            striped
            customStyles={customStyles}
          />
        </DataTableExtensions>
      </div>
    </>
  );
};

export default DailyReports;
